import { render, staticRenderFns } from "./t_zhuanke.vue?vue&type=template&id=cb13ccbc&scoped=true&"
import script from "./t_zhuanke.vue?vue&type=script&lang=js&"
export * from "./t_zhuanke.vue?vue&type=script&lang=js&"
import style0 from "./t_zhuanke.vue?vue&type=style&index=0&id=cb13ccbc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb13ccbc",
  null
  
)

export default component.exports